import { radioClasses } from '@mui/material';

import { SxProp } from 'src/types/mui';

export const radioFieldStyles: SxProp = {
  marginLeft: 1,
  [`& .${radioClasses.checked}`]: {
    borderColor: 'red',
  },
  [`& .${radioClasses.root}`]: {
    fontSize: '1rem',
  },
};

export const boxStyles = {
  display: 1,
  flexDirection: 'column',
} as const satisfies SxProp;

export const settingsStyles: SxProp = theme => ({
  border: theme.constantStyles?.paperBorder,
  borderRadius: theme.constantStyles?.paperBorderRadius,
  padding: '20px 24px',
  mt: 2,
});

export const titleDataSchemaStyles: SxProp = {
  borderBottom: '1px solid #D9D9D9',
  paddingBottom: '16px',
  marginBottom: '16px',
};
